var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 12,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66974 2.66671C2.66974 1.93337 3.26232 1.33337 3.99472 1.33337H9.32126L13.3162 5.33337V13.3334C13.3162 14.0667 12.7169 14.6667 11.9845 14.6667H3.98806C3.25566 14.6667 2.66309 14.0667 2.66309 13.3334L2.66974 2.66671ZM8.65544 2.33337V6.00004H12.3174L8.65544 2.33337Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9796,
    height: 16,
    fill: "#6F89A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcoGrey);
export default __webpack_public_path__ + "static/media/file-ico-grey.17662fc25ffb10fd4f427e54f9cfe2b6.svg";
export { ForwardRef as ReactComponent };